export enum NewCardFieldName {
  PAN = "ctpNewCardPan",
  EXPIRY_MONTH = "ctpNewCardExpiryMonth",
  EXPIRY_YEAR = "ctpNewCardExpiryYear",
  SECURITY_CODE = "ctpNewCardSecurityCode",
}
